import React from 'react';

const Experience = () => {
  return (
    <section id="experience" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Experience</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-primary-200"></div>
            
            <div className="relative pl-20 pb-12">
              <div className="absolute left-6 w-4 h-4 bg-primary-600 rounded-full border-4 border-white shadow-lg"></div>
              
              <div className="bg-white p-8 rounded-lg shadow-lg card-hover">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">Data Scientist</h3>
                    <h4 className="text-xl text-primary-600 font-semibold">Sanskriti University</h4>
                  </div>
                  <div className="text-right">
                    <div className="text-gray-600 font-medium">August 2024 - November 2024</div>
                    <div className="text-gray-500">
                      <i className="fas fa-map-marker-alt mr-2"></i>
                      Uttar Pradesh, India
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="fas fa-brain text-primary-600 mt-1 mr-3"></i>
                    <p className="text-gray-700">
                      <strong>Deep Learning Development:</strong> Developed advanced CNN models 
                      for medical image analysis, focusing on accuracy and performance optimization
                    </p>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="fas fa-search text-primary-600 mt-1 mr-3"></i>
                    <p className="text-gray-700">
                      <strong>Anomaly Detection:</strong> Implemented sophisticated anomaly detection 
                      algorithms for X-ray image analysis, improving diagnostic accuracy
                    </p>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="fas fa-chart-line text-primary-600 mt-1 mr-3"></i>
                    <p className="text-gray-700">
                      <strong>Performance Optimization:</strong> Enhanced model performance on 
                      complex medical datasets through advanced preprocessing and feature engineering
                    </p>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-2 mt-6">
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium">
                    Python
                  </span>
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium">
                    TensorFlow
                  </span>
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium">
                    CNN
                  </span>
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium">
                    Medical Imaging
                  </span>
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium">
                    Anomaly Detection
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
